<template>
	<v-card>
		<v-card-title>Reseller Portal</v-card-title>
		<v-card-text><translate>To get started with making orders: click the New Order button.</translate></v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'ResellerHome'
};
</script>
